<template>
  <w-dialog :dialog-state="dialogState" @handleClose="handleClose">
    <div slot="content" class="campus-code-container">
      <h3 class="campus-title">关注公众号，开启提醒</h3>
      <p class="campus-description color_9c">微信上也可以随时查看、 投递简历</p>
      <img :src="qrUrl" alt="">
      <p class="color_9c">微信扫码 管理网申</p>
    </div>
  </w-dialog>
</template>

<script>
	import WDialog from '../../../components/base/dialog'

	export default {
		name: 'campus-code',
		props: {
			dialogState: {
				type: Boolean,
				default: false
      },
      qrUrl: {
				type: String,
				default: ''
			}
		},
		data () {
			return {}
		},
		mounted () {
		},
		computed: {},
		watch: {},
		components: {
			WDialog
    },
    created(){
console.log(this.qrUrl)
    },
		methods: {
			handleClose () {
				this.$emit('handleClose')
			}
		}
	}
</script>

<style lang="scss" scoped>
  @import "../../../assets/css/public";
  .campus-code-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 340px;
    padding: 36px 0 54px;
    background-color: #FFffff;
    border-radius: 8px;
    .campus-title {
      font-size: 22px;
      font-weight: 500;
      margin-bottom: 14px;
    }
    .campus-description {
      margin-bottom: 32px;
    }
    img {
      width: 150px;
      height: 150px;
      margin-bottom: 24px;
    }
  }
</style>
